import { observer } from 'mobx-react';
import { action, computed, observable } from 'mobx';
import * as React from 'react';
import { inject, bind } from '../../../../utils/decorators';
import { UiStore } from '../../../../stores/UiStore';
import { ApiStore } from '../../../../stores/ApiStore';
import { BpsReferenzkraftKalibrierungPlatteStore } from '../../../../stores/BpsReferenzkraftKalibrierungPlatteStore';
import * as ApiTypesBps from '../../../../models/ApiTypesBpsPlatte';
import { Panel, Col, FormGroup, FormControl, Table, InputGroup, Row } from 'react-bootstrap';
import { IBpsReferenzkraftMesswerteResponse } from '../../../../models/ApiTypesBpsPlatte';
import BpsReferenzkraftVorbelastungPlatte from './BpsReferenzkraftVorbelastungPlatte';
import BpsReferenzkraftJustageInfo from './BpsReferenzkraftJustageInfo';
import Callout from '../../../site/Callout';
import * as ApiTypeFactory from '../../../../models/ApiTypeFactory';
import BpsReferenzkraftGesamtBeurteilung from '../rili2021/BpsReferenzkraftGesamtBeurteilung';

interface IBpsReferenzkraftRollensatzMesspunktBeurteilungProps {
  position: string;
  index: number;
  nachJustage: boolean;
}

@observer
class BpsReferenzkraftRollensatzMesspunktBeurteilung extends React.Component<IBpsReferenzkraftRollensatzMesspunktBeurteilungProps, {}> {
  @inject(BpsReferenzkraftKalibrierungPlatteStore) store: BpsReferenzkraftKalibrierungPlatteStore;

  @computed get beurteilungMesspunkt() {
    const { position, index, nachJustage } = this.props;
    let quelle: ApiTypesBps.IBpsReferenzkraftPlattensatz | null = null;
    if (position === 'links') {
      quelle = nachJustage ? this.store.datensatz.plattensatzJustage.links : this.store.datensatz.plattensatz.links;
    }
    if (position === 'rechts') {
      quelle = nachJustage ? this.store.datensatz.plattensatzJustage.rechts : this.store.datensatz.plattensatz.rechts;
    }
    if ((quelle !== null) && (quelle.messpunkte.length > index)) {
      if (quelle.messpunkte[index].beurteilung !== null) {
        return quelle.messpunkte[index].beurteilung === true ? 'i.O' : 'n.i.O';
      }
    }
    return '-';
  }

  render() {
    const beurteilung = this.beurteilungMesspunkt;
    let className = '';
    if (beurteilung !== null) {
      className = `beurteilung-${beurteilung.replace(/\./g, '').toLowerCase()}`;
    }
    return <div className={className}>{beurteilung}</div>;
  }
}

interface IBpsReferenzkraftRollensatzMessreiheProps {
  ziel: ApiTypesBps.IBpsReferenzkraftPlattensatz;
  messreihe: number;
  nachJustage: boolean;
}

@observer
class BpsReferenzkraftRollensatzMessreihe extends React.Component<IBpsReferenzkraftRollensatzMessreiheProps, {}> {

  @inject(ApiStore) apiStore: ApiStore;
  @inject(BpsReferenzkraftKalibrierungPlatteStore) store: BpsReferenzkraftKalibrierungPlatteStore;

  @bind @action handleMesswertBpsChanged(index: number, ev: React.FormEvent<FormControl>) {
    this.props.ziel.messpunkte[index].messwerte[this.props.messreihe].bps = (ev.target as HTMLInputElement).valueAsNumber;
    this.store.berechneReferenzWerte();
  }

  @bind @action handleMesswertSensorChanged(index: number, ev: React.FormEvent<FormControl>) {
    this.props.ziel.messpunkte[index].messwerte[this.props.messreihe].sensor = (ev.target as HTMLInputElement).valueAsNumber;
    this.store.berechneReferenzWerte();
  }

  getMesswertBps(index: number) {
    const val = this.props.ziel.messpunkte[index].messwerte[this.props.messreihe].bps;
    return (val !== null) ? val : undefined;
  }

  getMesswertSensor(index: number) {
    const val = this.props.ziel.messpunkte[index].messwerte[this.props.messreihe].sensor;
    return (val !== null) ? val : undefined;
  }

  render() {
    const { ziel } = this.props;
    return (
      <div>
        <h4>Messreihe {this.props.messreihe + 1}</h4>
        <Table striped={false} bordered={false} condensed={true} hover={false} className="bps-auswertung">
          <thead>
            <tr>
                <th>Kraftstufe</th>
                <th>Messwert BPS</th>
                <th>Referenzwert</th>
                <th>Abweichung</th>
                <th style={{width: '48px'}}/>
            </tr>
          </thead>
          <tbody>
            {ziel.messpunkte.map((mp, index) =>
              <tr key={`mp-${index}`}>
                <td>{mp.anzeige}</td>
                <td>
                  <FormGroup style={{margin: '0px'}}>
                    <InputGroup>
                      <FormControl
                        type="number"
                        step="any"
                        onChange={(e) => this.handleMesswertBpsChanged(index, e)}
                        readOnly={this.store.readOnly}
                        value={this.getMesswertBps(index)}
                      />
                    </InputGroup>
                  </FormGroup>
                </td>
                <td>
                  <FormGroup style={{margin: '0px'}}>
                    <InputGroup>
                      <FormControl
                        type="number"
                        step="any"
                        onChange={(e) => this.handleMesswertSensorChanged(index, e)}
                        readOnly={this.store.readOnly}
                        value={this.getMesswertSensor(index)}
                      />
                    </InputGroup>
                  </FormGroup>
                </td>
                <td>{mp.messwerte[this.props.messreihe].messwertabweichung}</td>
                <td><BpsReferenzkraftRollensatzMesspunktBeurteilung position={ziel.position} index={index} nachJustage={this.props.nachJustage}/></td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    );
  }
}

@observer
class BpsReferenzkraftPlattensatz extends React.Component<{ ziel: ApiTypesBps.IBpsReferenzkraftPlattensatz; nachJustage: boolean }, {}> {
  @inject(BpsReferenzkraftKalibrierungPlatteStore) store: BpsReferenzkraftKalibrierungPlatteStore;
  render() {
    const { ziel } = this.props;
    let header = 'Platte ' + ziel.position;
    let zusatz = '';
    if (this.props.nachJustage) {
      zusatz = 'nach Justage';
    }
    return (
      <div>
        {/* Vorbelastung */}
        <Panel header={`${header} - Vorbelastung ${zusatz}`} collapsible={true} defaultExpanded={true}>
          <BpsReferenzkraftVorbelastungPlatte ziel={ziel}/>
        </Panel>
        {/* Eingabe Messwerte */}
        <Panel header={`${header} - Messung ${zusatz}`} collapsible={true} defaultExpanded={true}>
          <BpsReferenzkraftRollensatzMessreihe messreihe={0} ziel={ziel} nachJustage={this.props.nachJustage}/>
          <BpsReferenzkraftRollensatzMessreihe messreihe={1} ziel={ziel} nachJustage={this.props.nachJustage}/>
          <BpsReferenzkraftRollensatzMessreihe messreihe={2} ziel={ziel} nachJustage={this.props.nachJustage}/>
        </Panel>
      </div>
    );
  }
}

/** Exportierte Komponente für die Messwerteingabe und -auswertung der BPS Plattensätze links und rechts nach 2021er Rili */
@observer
export default class BpsReferenzkraftPlattensaetze extends React.Component<{}, {}> {

  @inject(UiStore) uiStore: UiStore;
  @inject(ApiStore) apiStore: ApiStore;
  @inject(BpsReferenzkraftKalibrierungPlatteStore) store: BpsReferenzkraftKalibrierungPlatteStore;

  @observable messpunkte: IBpsReferenzkraftMesswerteResponse = [];

  @bind @action setReferenzpunkte(referenzpunkte: IBpsReferenzkraftMesswerteResponse) {
    const { plattensatz } = this.store.datensatz;
    const anzahlReferenzpunkte = referenzpunkte.length;
    // Anzahl der Messpunkte der Rollensätze an Anzahl der Referenzmesspunkte anpassen
    if (referenzpunkte.length !== plattensatz.links.messpunkte.length || referenzpunkte.length || plattensatz.rechts.messpunkte.length) {
      var rollensaetze = [plattensatz.links, plattensatz.rechts];
      // Bei gewählter und aktiver Justage müssen auch die Messreihen für die Eingabe nach Justage angepasst werden
      if (this.store.datensatz.justageInfo === 'justage') {
        rollensaetze.push(this.store.datensatz.plattensatz.links);
        rollensaetze.push(this.store.datensatz.plattensatz.rechts);
      }
      rollensaetze.forEach(rs => {
        if (rs.messpunkte.length < referenzpunkte.length) {
          // Mehr Referenzpunkte als Messpunkte
          for (let i = rs.messpunkte.length; i < anzahlReferenzpunkte; i++) {
            rs.messpunkte.push(ApiTypeFactory.leererBPSMesspunktPlatte());
          }
        } else if (rs.messpunkte.length > anzahlReferenzpunkte) {
          rs.messpunkte = rs.messpunkte.slice(0, anzahlReferenzpunkte);
        }
        // Daten aus Referenzpunkten übernehmen
        referenzpunkte.forEach((rp, index) => {
          rs.messpunkte[index].anzeige = rp.anzeige;
          // Messwerte BPS vorbelegen, erleichtert die Eingabe
          rs.messpunkte[index].messwerte.forEach((mp) => { mp.bps = rp.anzeige; });
        });
      });
    }
  }

  @bind @action async messpunkteAbrufen() {
    const { datensatz, kalibrierGegenstand } = this.store;
    if (kalibrierGegenstand && kalibrierGegenstand.objekt && datensatz.messbereich) {
      const response = await this.store.messpunkteAbrufen();
      if (response && response.ok) {
        this.setReferenzpunkte(response.json);
      }
    }
  }

  @bind @action handleMessbereichChanged(event: React.FormEvent<FormControl>) {
    let val = parseFloat((event.target as HTMLInputElement).value);
    this.store.setMessbereich(val);
    this.messpunkteAbrufen();
  }

  render() {
    const { datensatz } = this.store;
    return (
      <div>
        <Panel header="Kalibrierung Plattensätze - Messbereich" collapsible={true} defaultExpanded={true}>
            <Table striped={false} bordered={false} condensed={true} hover={false} className="bps-pruefortparameter">
              <tbody>
                <tr>
                  <td style={{minWidth: '64px !important'}}> von </td>
                  <td style={{maxWidth: '110px'}}>
                    <FormGroup>
                      <InputGroup>
                        <FormControl type="number" disabled={true} value={0}/>
                        <InputGroup.Addon>N</InputGroup.Addon>
                      </InputGroup>
                    </FormGroup>
                  </td>
                  <td style={{minWidth: '64px !important'}}> bis </td>
                  <td style={{maxWidth: '140px'}}>
                    <FormGroup>
                      <InputGroup>
                        {/* @todo: onBlur ungeschickt/controlled uncontrolled */}
                        <FormControl type="number" step="any" onChange={this.handleMessbereichChanged} value={datensatz.messbereich} disabled={this.store.readOnly} />
                        <InputGroup.Addon>N</InputGroup.Addon>
                      </InputGroup>
                    </FormGroup>
                  </td>
                </tr>
              </tbody>
            </Table>
        </Panel>
        {(this.store.messbereichGueltig()) ?
          <div>
            <Row style={{maxWidth: '1600px !important'}}>
              <Col md={6} sm={12}><BpsReferenzkraftPlattensatz ziel={datensatz.plattensatz.links} nachJustage={false}/></Col>
              <Col md={6} sm={12}><BpsReferenzkraftPlattensatz ziel={datensatz.plattensatz.rechts} nachJustage={false}/></Col>
            </Row>
            <BpsReferenzkraftGesamtBeurteilung ziel={datensatz.gesamtErgebnis} nachJustage={false}/>
            <BpsReferenzkraftJustageInfo/>
            {(this.store.datensatz.justageInfo === 'justage') &&
              <div>
                <Row style={{maxWidth: '1600px !important'}}>
                  <Col md={6} sm={12}><BpsReferenzkraftPlattensatz ziel={datensatz.plattensatzJustage.links} nachJustage={true}/></Col>
                  <Col md={6} sm={12}><BpsReferenzkraftPlattensatz ziel={datensatz.plattensatzJustage.rechts} nachJustage={true}/></Col>
                </Row>
                <BpsReferenzkraftGesamtBeurteilung ziel={datensatz.plattensatzJustage.gesamtErgebnis} nachJustage={true}/>
              </div>
            }
          </div>
          :
          <Callout bsStyle="warning">
            Zur Messwerteingabe bitte einen gültigen Messbereich angeben.
          </Callout>
          }
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/bps/platte/BpsReferenzkraftPlattensaetze.tsx